import { Role } from '@/core/components/auth/auth.types'
import { getCollectionByIdQueryOptions } from '@/core/components/collections/collectionQueryOptions'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { propertiesQueryOptions } from '@/core/components/sites/propertyQueryOptions'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/collection/$collectionId/edit/'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    // PropertyManager is read-only on Collections: it sees the listing but the
    // edit route is closed to it (differs from Groups on purpose).
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Editor'] ||
      auth.user?.role === Role['Blogger'] ||
      auth.user?.role === Role.PropertyManager
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth }, params: { collectionId } }) => {
    const collection = queryClient.ensureQueryData(
      getCollectionByIdQueryOptions(collectionId, auth.token!)
    )
    // Options for the member multi-select.
    const properties = queryClient.ensureQueryData(
      propertiesQueryOptions(auth.token!)
    )

    return { collection, properties }
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
